import { useEffect, useState } from 'react';

import { useFeatureFlag } from '../components/LaunchDarklyProvider';

type FlagValue = unknown;

type UseFeatureFlagOnce2ReturnValue = {
  value: FlagValue;
  loading: boolean;
};

/**
 * Ensures stable feature flag value and loading state without flickering during additional fetches.
 */
const useFeatureFlagOnce2 = (
  flagName: string,
  defaultValue = false,
): UseFeatureFlagOnce2ReturnValue => {
  const { value, loading } = useFeatureFlag(flagName, defaultValue);
  const [stableLoading, setStableLoading] = useState<boolean>(true);
  const [stableValue, setStableValue] = useState<FlagValue>(defaultValue);

  useEffect(() => {
    if (!loading && stableLoading === true) {
      setStableLoading(false);
    }
  }, [loading, stableLoading]);

  useEffect(() => {
    if (!loading && value !== stableValue) {
      setStableValue(value);
    }
  }, [loading, stableValue, value]);

  return {
    value: stableValue,
    loading: stableLoading,
  };
};

export default useFeatureFlagOnce2;
